import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import StatusMessages2 from '../../../components/StatusMessages2';

import { saveAdmin,listBrokerAdmins } from '../../../actions/brokers';

import SimpleReactValidator from 'simple-react-validator'

class BrokerAdminForm extends Component {

    constructor(props){
        super(props);

        this.validator=new SimpleReactValidator();
        const { user } = this.props;

        this.state = {
            user: {},
            broker_admin: {
                ...this.props.broker_admin
            },
            broker_admin_loading: false,
            filter: {
                insurer: user.userInfo.insurer,
                intermediary_type:'BROKERAGE',
            }
        };        
    }
    componentDidMount(){
        const { listBrokerAdmins } = this.props;;
        listBrokerAdmins(this.state.filter);
    }
    componentWillReceiveProps(nextProps){
        const { broker_admin } = nextProps;

        this.setState({
            broker_admin: broker_admin || {},
            updated_broker_admin: {
                id: broker_admin ? broker_admin.id : ''
            },
        });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { broker_admin, updated_broker_admin, user } = this.state;

        this.setState({ broker_loading: true });

        if(this.validator.allValid()){
            this.validator.hideMessages();
            let handler = {};

            if(broker_admin.hasOwnProperty('id')){
                handler = this.props.updateInsurer(updated_broker_admin);
            }
            else{

                let admin = {
                    user: {
                        ...user,
                        is_active: "True"
                    },
                    profile: {
                        intermediary: broker_admin.company_name
                    },
                    type: "intermediary_admin"
                }
                
                handler = this.props.saveAdmin(admin).then(()=>{
                    this.props.listBrokerAdmins(this.state.filter);
                });
            }

            handler
                .then((response)=>{
                    this.setState({ broker_loading: false });
                })
                .catch((error)=>{
                    this.setState({ broker_loading: false });
                });
        } else{
            this.validator.showMessages();
            this.forceUpdate()
        }  
    }

    onChange = (e) => {
        e.preventDefault();

        const { broker_admin, user } = this.state;
        const { name, value } = e.target;

        this.setState({ 
            broker_admin: {
                ...broker_admin,
                [name]: value
            },
            user: {
                ...user,
                [name]: value
            }
        });
    }

    render(){
        const { brokers } = this.props;
        const { broker_loading } = this.state;
        
        return(
            <form 
                className="form-horizontal" 
                noValidate
                onSubmit={ this.onSubmit }>

                {
                    brokers.errorCreateBrokerAdmin && ! broker_loading ?
                        <StatusMessages2 
                            type="error"
                            message={ brokers.errorMessageCreateBrokerAdmin } />
                    :
                        null
                }
                {
                    brokers.success && ! broker_loading ?
                        <StatusMessages2 
                            type="success" 
                            message={ brokers.successMessage.Info } />
                    : null
                }
            
                <div className="form-group">
                    <label className="col-sm-4 control-label">Username: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="username" 
                            className="form-control" 
                            onChange={this.onChange} />
                        {this.validator.message('username', this.state.broker_admin.username, 'required', 'text-danger' )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Email: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="email" 
                            className="form-control" 
                            
                            onChange={this.onChange}  />
                             {this.validator.message('email', this.state.broker_admin.email, 'required', 'text-danger' )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">First Name: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="first_name" 
                            className="form-control" 
                            
                            onChange={this.onChange}  />
                         {this.validator.message('first_name', this.state.broker_admin.first_name, 'required', 'text-danger' )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Last Name: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="last_name" 
                            className="form-control" 
                            
                            onChange={this.onChange}  />
                         {this.validator.message('last_name', this.state.broker_admin.last_name, 'required', 'text-danger' )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Other Names:</label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="other_names" 
                            className="form-control"
                            onChange={this.onChange}   />
                         {this.validator.message('other_names', this.state.broker_admin.other_names, 'required', 'text-danger' )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Phone Number: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="phone" 
                            className="form-control" 
                            
                            onChange={this.onChange}  />
                             {this.validator.message('phone', this.state.broker_admin.phone, 'required', 'text-danger' )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Company: <span className="text-danger">*</span></label>
                    <div className="col-sm-8">
                    {
                        brokers.brokers.length > 0 ?
                        
                        <select 
                            className="form-control" 
                            name="company_name" 
                            onChange={ this.onChange }>

                            <option value="">-- Select Company --</option>
                            
                            {
                                brokers.brokers.map((broker, index)=>{
                                    return(
                                        <option key={ index } value={ broker.id }>
                                            { broker.name }
                                        </option>
                                    )
                                })
                            }
                        </select>
                        :
                        null
                        
                    }
                     {this.validator.message('company_name', this.state.broker_admin.company_name, 'required', 'text-danger' )}
                    </div>
                </div>

                <div className="form-group">
                    <div className="col-sm-8 col-sm-offset-4">
                        <button type="submit" className="btn btn-success">
                            <i className="icon ion-checkmark"></i> Create Administrator
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    brokers: state.brokers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ saveAdmin,listBrokerAdmins }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BrokerAdminForm);



// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/BrokerAdminForm.jsx